import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { X, Printer, QrCode } from "@phosphor-icons/react";

export default function AssetQrDialog({ asset, onClose }) {
  const printRef = useRef(null);
  const url = `${window.location.origin}/docket?asset=${asset.id}`;

  const print = () => {
    const html = printRef.current?.innerHTML;
    const w = window.open("", "_blank", "width=480,height=640");
    if (!w) return;
    w.document.write(`<html><head><title>QR — ${asset.asset_no}</title>
      <style>body{font-family:Montserrat,Arial,sans-serif;text-align:center;padding:32px;color:#0c100f}
      h1{font-size:22px;margin:8px 0} .pin{font-size:34px;letter-spacing:8px;font-weight:800;margin-top:12px}
      .sub{color:#555;font-size:13px}</style></head><body>${html}</body></html>`);
    w.document.close();
    w.focus();
    setTimeout(() => { w.print(); w.close(); }, 300);
  };

  return (
    <div className="fixed inset-0 z-[60] bg-[rgba(26,26,26,0.42)] flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-surface-panel border border-border-warm rounded-[14px] overflow-hidden shadow-modal w-full max-w-sm" onClick={(e) => e.stopPropagation()} data-testid="asset-qr-dialog">
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200 bg-equipr-black text-white">
          <h3 className="font-bold text-sm inline-flex items-center gap-1.5"><QrCode size={16} /> Docket QR — {asset.asset_no}</h3>
          <button onClick={onClose} data-testid="asset-qr-close"><X size={18} /></button>
        </div>
        <div className="p-6 text-center">
          <div ref={printRef}>
            <h1>{asset.asset_no}</h1>
            <div className="sub" style={{ color: "#555", fontSize: 13 }}>{asset.asset_type || ""} · Scan to submit a hire docket</div>
            <div style={{ display: "flex", justifyContent: "center", margin: "18px 0" }}>
              <QRCodeCanvas value={url} size={200} level="M" includeMargin data-testid="asset-qr-canvas" />
            </div>
            <div className="sub" style={{ color: "#555", fontSize: 13 }}>Asset PIN</div>
            <div className="pin" data-testid="asset-qr-pin">{asset.docket_pin || "----"}</div>
          </div>
          <p className="text-[11px] text-gray-400 mt-3 break-all">{url}</p>
          <button onClick={print} data-testid="asset-qr-print"
            className="w-full h-10 mt-4 bg-equipr-yellow text-equipr-black font-bold rounded-none hover:bg-equipr-yellow-dark inline-flex items-center justify-center gap-1.5">
            <Printer size={16} weight="bold" /> Print QR + PIN
          </button>
        </div>
      </div>
    </div>
  );
}
